/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadmitToFacilityRequest
 */
export interface ReadmitToFacilityRequest {
    /**
     * 
     */
    hospitalized_lead_ids: Array<string>;
    /**
     * 
     */
    new_lead_id: string;
    /**
     * 
     */
    move_out_date: string;
    /**
     * 
     */
    move_out_comment?: string;
    /**
     * 
     */
    move_in_date: string;
    /**
     * 
     */
    scheduled_move_out_date?: string;
    /**
     * 
     */
    bed_id?: string;
    /**
     * 
     */
    stay_type: ReadmitToFacilityRequestStayTypeEnum;
    /**
     * 
     */
    comment?: string;
}


/**
 * @export
 */
export const ReadmitToFacilityRequestStayTypeEnum = {
    LongTerm: 'Long-Term',
    ShortTerm: 'Short-Term',
} as const;
export type ReadmitToFacilityRequestStayTypeEnum = typeof ReadmitToFacilityRequestStayTypeEnum[keyof typeof ReadmitToFacilityRequestStayTypeEnum];


/**
 * Check if a given object implements the ReadmitToFacilityRequest interface.
 */
export function instanceOfReadmitToFacilityRequest(value: object): value is ReadmitToFacilityRequest {
    if (!('hospitalized_lead_ids' in value) || value['hospitalized_lead_ids'] === undefined) return false;
    if (!('new_lead_id' in value) || value['new_lead_id'] === undefined) return false;
    if (!('move_out_date' in value) || value['move_out_date'] === undefined) return false;
    if (!('move_in_date' in value) || value['move_in_date'] === undefined) return false;
    if (!('stay_type' in value) || value['stay_type'] === undefined) return false;
    return true;
}

export function ReadmitToFacilityRequestFromJSON(json: any): ReadmitToFacilityRequest {
    return ReadmitToFacilityRequestFromJSONTyped(json, false);
}

export function ReadmitToFacilityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadmitToFacilityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hospitalized_lead_ids': json['hospitalized_lead_ids'],
        'new_lead_id': json['new_lead_id'],
        'move_out_date': json['move_out_date'],
        'move_out_comment': json['move_out_comment'] == null ? undefined : json['move_out_comment'],
        'move_in_date': json['move_in_date'],
        'scheduled_move_out_date': json['scheduled_move_out_date'] == null ? undefined : json['scheduled_move_out_date'],
        'bed_id': json['bed_id'] == null ? undefined : json['bed_id'],
        'stay_type': json['stay_type'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function ReadmitToFacilityRequestToJSON(json: any): ReadmitToFacilityRequest {
    return ReadmitToFacilityRequestToJSONTyped(json, false);
}

export function ReadmitToFacilityRequestToJSONTyped(value?: ReadmitToFacilityRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hospitalized_lead_ids': value['hospitalized_lead_ids'],
        'new_lead_id': value['new_lead_id'],
        'move_out_date': value['move_out_date'],
        'move_out_comment': value['move_out_comment'],
        'move_in_date': value['move_in_date'],
        'scheduled_move_out_date': value['scheduled_move_out_date'],
        'bed_id': value['bed_id'],
        'stay_type': value['stay_type'],
        'comment': value['comment'],
    };
}

